import { Injectable } from '@angular/core';
import { SettingsService } from '@common-modules/shared/config/settings.service';
import { environment } from 'projects/thin-client/src/environments/environment';
import { ThinClientSettings } from './tc-settings';

@Injectable({ providedIn: 'root' })
export class TCSettingsService {
  constructor(private _settingsService: SettingsService) {}

  get geoServer(): { url: string } {
    return this.thinClientSettings.geoServer ?? environment.geoServer;
  }

  get thinClientSettings(): ThinClientSettings {
    // This should be improved when we have time.
    return this._settingsService.settings as any as ThinClientSettings;
  }
}
